<template>
  <div>
    <my-asidebar v-bind:active-tab="'booking'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Rezervasyon</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Rezervasyon</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <agency-booking-confirmation-list></agency-booking-confirmation-list>
      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import AgencyBookingConfirmationList from "../component/booking/AgencyBookingConfirmationList";
import Vue from "vue";

export default {
  name: "AgencyBookingConfirmationListPage",
  data:function (){
    return{
      bookingList: null,
    }
  },
  components: {AgencyBookingConfirmationList, MyAsidebar, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_AGENCY_BOOKING_CONFIRMATION_LIST"]) this.$router.push("/");
    // this.bookingList = null;
    // this.$store.dispatch("loadBookingList").then(response =>{
    //   Vue.set(this,"bookingList", response);
    // });
    this.$store.dispatch("loadAgencyList");
    this.$store.dispatch("loadUserList");
  }
}
</script>

<style scoped>

</style>